module.exports = __webpack_public_path__ + "img/nineFooter.2a773f6f.png";